const DR_PREFIX_REGEX = /^\s*(dr\.?|DR\.?|Dr\.?)\s+/;

export const stripDrPrefix = (name: string): string =>
  name.replace(DR_PREFIX_REGEX, "").trimStart();

export const formatDoctorName = (
  name: string | null | undefined,
  showPrefix: boolean
): string => {
  if (!name) return "";
  const bare = stripDrPrefix(name);
  return showPrefix ? `Dr. ${bare}` : bare;
};
